var SCAAFFCustomerReferSetting = {
    "program": {
        "active": false,
        "shop": "rumi-rose-merchandise.myshopify.com",
        "incentive": {
            "type": "percentage",
            "value": "10.00",
            "price_rule_id": 1210216611934,
            "coupon": "UPPROMOTE_CUSTOMER_REFERRAL"
        },
        "program": "ODI0NTc="
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "Refer & Earn",
            "refer_background_color": "#030f1a",
            "refer_text_color": "#ffffff",
            "web_position": "center-bottom",
            "mobile_position": "left-bottom"
        },
        "refer_customer_invite": {
            "popup_header": "Invite & Get 10% from friend's orders",
            "popup_description": "Send your friends a 10% discount off their purchase. Once they make a purchase, you\u2019ll earn 10% for each order as well! This reward can be redeemed for coupons or cash.",
            "button_text_get_invite": "Get invite link",
            "button_copy_invite": "Copy invite link",
            "popup_background_color": "#1d85e8",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "You got 10% Off",
            "shop_description": "Congrats! Your friend has gifted you a coupon. Coupon will be automatically applied at the checkout page.",
            "shop_button_text": "Shop now",
            "shop_background_color": "#0d0d0e",
            "shop_text_color": "#ffffff"
        }
    }
}